module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/access-4cabcf757a9998c060283d7035ccfe9d.png";